<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-setting"></i>
              站点设置
            </h1>
            <p class="page-subtitle">配置网站基本信息、SEO设置和联系方式</p>
          </div>
        </div>

        <I18nLangBar
          v-model="contentLang"
          entity-type="setting"
          :entity-id="formData.id || ''"
          :source-lang="resolvedSourceLang"
          :locales="contentLocales"
          @change="onSettingLangChange"
          @translated="onSettingTranslated" />

        <el-form ref="articleForm" :model="formData" :rules="rules" label-width="120px">
          <el-row :gutter="24">
            <el-col :span="12" class="content-left">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-info"></i>
                    基本信息
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="网站名称" prop="web_name">
                    <el-input v-model="formData.web_name" placeholder="请输入网站名称"></el-input>
                  </el-form-item>
                  <el-form-item label="版权信息" prop="copyright">
                    <el-input v-model="formData.copyright" placeholder="请输入版权信息"></el-input>
                  </el-form-item>
                  <el-form-item label="联系邮箱" prop="email">
                    <el-input v-model="formData.email" placeholder="请输入联系邮箱"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="phone">
                    <el-input v-model="formData.phone" placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                  <el-form-item label="联系地址" prop="address">
                    <el-input v-model="formData.address" placeholder="请输入联系地址"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-search"></i>
                    SEO设置
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="SEO标题" prop="seo_title">
                    <el-input v-model="formData.seo_title" placeholder="请输入SEO标题"></el-input>
                  </el-form-item>
                  <el-form-item label="SEO关键词" prop="seo_keywords">
                    <el-input v-model="formData.seo_keywords" placeholder="请输入SEO关键词，多个关键词用英文逗号分隔"></el-input>
                  </el-form-item>
                  <el-form-item label="SEO描述" prop="seo_description">
                    <el-input :rows="4" type="textarea" v-model="formData.seo_description" placeholder="请输入SEO描述"></el-input>
                  </el-form-item>
                </div>
              </div>

            </el-col>

            <!-- 右侧短栏：与左侧基本信息/SEO 持平 -->

            <el-col :span="12" class="content-right">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-picture"></i>
                    站点LOGO
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="站点LOGO" prop="web_logo" label-width="0">
                    <div class="logo-upload">
                      <el-upload
                        class="avatar-uploader"
                        action="/service/upload/image"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :limit="1"
                        :headers="uploadHeaders">
                        <img v-if="formData.web_logo" :src="formData.web_logo" class="avatar"/>
                        <div v-else class="upload-placeholder">
                          <i class="el-icon-plus avatar-uploader-icon"></i>
                          <div class="upload-text">点击上传LOGO</div>
                        </div>
                      </el-upload>
                      <div class="upload-tips">
                        <p>• 建议尺寸：200x60像素</p>
                        <p>• 支持格式：JPG、PNG</p>
                        <p>• 文件大小：不超过2MB</p>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-lock"></i>
                    安全设置
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="OTP二次验证" label-width="110px">
                    <el-switch
                      v-model="formData.otp_enabled"
                      active-value="1"
                      inactive-value="0"
                      active-text="开启"
                      inactive-text="关闭">
                    </el-switch>
                    <p class="otp-tip">开启后，管理员登录需输入 Authenticator 二次验证码</p>
                  </el-form-item>
                </div>
              </div>

              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-setting"></i>
                    保存设置
                  </h3>
                </div>
                <div class="card-content">
                  <div class="action-buttons">
                    <el-button
                      size="medium"
                      type="primary"
                      class="save-btn"
                      :disabled="loadingStaus"
                      @click="saveConfirm">
                      <i class="el-icon-check"></i>
                      保存设置
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 下方全宽：统计/自定义/翻译，不拉长左右栏 -->
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-data-analysis"></i>
                    统计代码
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="统计代码" prop="analytics">
                    <el-input :rows="6" type="textarea" v-model="formData.analytics" placeholder="请输入网站统计代码"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-menu"></i>
                    自定义信息
                  </h3>
                  <div class="card-actions">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addItem">添加信息</el-button>
                  </div>
                </div>
                <div class="card-content">
                  <div class="custom-table">
                    <el-table :data="formData.customize_info" stripe>
                      <el-table-column prop="key" label="标识" width="150">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.title" placeholder="输入标识"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="content" label="内容">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.content" type="textarea" :rows="3" placeholder="输入内容"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="80" align="center">
                        <template slot-scope="scope">
                          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteItem(scope.$index)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <!-- 翻译区移到左侧主栏，避免右侧过长 -->
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-s-opportunity"></i>
                    翻译供应商（OpenAI 兼容）
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="Base URL">
                    <el-input v-model="formData.translate_base_url" placeholder="例如 https://open.bigmodel.cn/api/paas/v4 或 https://api.deepseek.com/v1"></el-input>
                  </el-form-item>
                  <el-form-item label="API Key">
                    <el-input v-model="formData.translate_api_key" type="password" show-password placeholder="Bearer Token"></el-input>
                  </el-form-item>
                  <el-form-item label="Model">
                    <div class="model-picker">
                      <el-input v-model="formData.translate_model" placeholder="可手动填写，或先拉取后勾选" style="margin-bottom: 8px;"></el-input>
                      <el-button size="mini" type="primary" plain :loading="modelLoading" @click="fetchProviderModels">拉取可用模型</el-button>
                      <p class="otp-tip">批量翻译请用快模型（如 glm-4-flash）。glm-5.3-flash 会强制深度思考，长文章极易卡住。</p>
                      <p v-if="modelFetchHint" class="otp-tip">{{ modelFetchHint }}</p>
                      <el-radio-group v-if="providerModels.length" v-model="formData.translate_model" class="model-radio-group">
                        <el-radio v-for="m in providerModels" :key="m" :label="m" border class="model-radio">{{ m }}</el-radio>
                      </el-radio-group>
                    </div>
                  </el-form-item>
                  <el-form-item label="源语言（主表原文）">
                    <el-select v-model="formData.translate_source_lang" placeholder="选择或自动识别" style="width:100%">
                      <el-option label="自动识别（按正文判断）" value="auto"></el-option>
                      <el-option label="English（英语，外贸站推荐）" value="en"></el-option>
                      <el-option label="中文（简体）" value="zh"></el-option>
                      <el-option label="中文（繁體）" value="tw"></el-option>
                      <el-option label="العربية（阿拉伯语）" value="ar"></el-option>
                      <el-option label="Español（西班牙语）" value="es"></el-option>
                      <el-option label="Русский（俄语）" value="ru"></el-option>
                      <el-option label="Nederlands（荷兰语）" value="nl"></el-option>
                      <el-option label="Polski（波兰语）" value="pl"></el-option>
                      <el-option label="Italiano（意大利语）" value="it"></el-option>
                      <el-option label="Français（法语）" value="fr"></el-option>
                      <el-option label="Deutsch（德语）" value="de"></el-option>
                      <el-option label="Português（葡萄牙语）" value="pt"></el-option>
                      <el-option label="日本語（日语）" value="ja"></el-option>
                      <el-option label="한국어（韩语）" value="ko"></el-option>
                      <el-option label="हिन्दी（印地语）" value="hi"></el-option>
                      <el-option label="Türkçe（土耳其语）" value="tr"></el-option>
                      <el-option label="Bahasa Indonesia（印尼语）" value="id"></el-option>
                      <el-option label="اردو（乌尔都语）" value="ur"></el-option>
                      <el-option label="Tiếng Việt（越南语）" value="vi"></el-option>
                      <el-option label="ไทย（泰语）" value="th"></el-option>
                    </el-select>
                    <p class="otp-tip">主表存源语言原文；其它语言进翻译表。支持 20 种语言。外贸站一般选 English。</p>
                  </el-form-item>
                  <el-form-item label="目标语言">
                    <el-checkbox-group v-model="targetLangChecks" class="target-lang-group">
                      <el-checkbox label="zh">中文（简体）</el-checkbox>
                      <el-checkbox label="tw">中文（繁體）</el-checkbox>
                      <el-checkbox label="en">English（英语）</el-checkbox>
                      <el-checkbox label="ar">العربية（阿拉伯语）</el-checkbox>
                      <el-checkbox label="es">Español（西班牙语）</el-checkbox>
                      <el-checkbox label="ru">Русский（俄语）</el-checkbox>
                      <el-checkbox label="nl">Nederlands（荷兰语）</el-checkbox>
                      <el-checkbox label="pl">Polski（波兰语）</el-checkbox>
                      <el-checkbox label="it">Italiano（意大利语）</el-checkbox>
                      <el-checkbox label="fr">Français（法语）</el-checkbox>
                      <el-checkbox label="de">Deutsch（德语）</el-checkbox>
                      <el-checkbox label="pt">Português（葡萄牙语）</el-checkbox>
                      <el-checkbox label="ja">日本語（日语）</el-checkbox>
                      <el-checkbox label="ko">한국어（韩语）</el-checkbox>
                      <el-checkbox label="hi">हिन्दी（印地语）</el-checkbox>
                      <el-checkbox label="tr">Türkçe（土耳其语）</el-checkbox>
                      <el-checkbox label="id">Bahasa Indonesia（印尼语）</el-checkbox>
                      <el-checkbox label="ur">اردو（乌尔都语）</el-checkbox>
                      <el-checkbox label="vi">Tiếng Việt（越南语）</el-checkbox>
                      <el-checkbox label="th">ไทย（泰语）</el-checkbox>
                    </el-checkbox-group>
                    <div class="target-lang-actions">
                      <el-button size="mini" type="text" @click="checkAllTargetLangs">全选</el-button>
                      <el-button size="mini" type="text" @click="uncheckAllTargetLangs">清空</el-button>
                      <el-button size="mini" type="text" @click="checkNewLangs">只勾选新增语言</el-button>
                    </div>
                    <p class="otp-tip">不要勾选与源语言相同的项。新增 15 种语言首次翻译需要在下方"历史数据翻译补全"里跑批量任务。</p>
                  </el-form-item>
                  <el-form-item label="接口访问 Key">
                    <div class="access-key-row">
                      <el-input v-model="formData.translate_access_key" placeholder="官网前台调用 /api/ola/i18n/* 时放在 x-translate-key 请求头"></el-input>
                      <el-button size="mini" type="primary" plain @click="genAccessKey">随机生成</el-button>
                    </div>
                    <p class="otp-tip">前台翻译/语种接口除 x-api-key 外还需带 x-translate-key。留空时这两个接口一律返回 403；修改后官网前端需同步更新。</p>
                  </el-form-item>
                </div>
              </div>

              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-s-grid"></i>
                    历史数据翻译补全
                  </h3>
                </div>
                <div class="card-content">
                  <p class="otp-tip">主表原文不变。短文本打包翻译；长文章 HTML 会按段落分块译。已译且原文未改的会跳过。总进度按实体条数计，交期+颜色占绝大多数。模型请用 glm-4.5-air。</p>
                  <el-form-item label="内容类型">
                    <el-checkbox :indeterminate="batchIndeterminate" v-model="batchCheckAll" @change="onBatchCheckAll">全选</el-checkbox>
                    <el-checkbox-group v-model="batchTypes" @change="onBatchTypesChange" style="margin-top: 8px;">
                      <el-checkbox v-for="t in batchTypeOptions" :key="t.value" :label="t.value">{{ t.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="每批条数">
                    <el-input-number v-model="batchLimit" :min="5" :max="50" :disabled="batchRunning"></el-input-number>
                    <p class="otp-tip">服务端会并发/打包请求。颜色、交期等短文本会多条合并成一次 API 调用。</p>
                  </el-form-item>
                  <div class="action-buttons" style="margin-bottom: 12px;">
                    <el-button type="primary" :loading="batchStarting" :disabled="batchRunning || !batchTypes.length" @click="startBatchTranslate">一键补全历史翻译</el-button>
                    <el-button :disabled="!batchRunning" @click="stopBatchTranslate">停止</el-button>
                  </div>
                  <div v-if="batchJobId || batchLog.length || batchRunning" class="batch-progress">
                    <el-progress :percentage="batchPercent" :status="batchProgressStatus"></el-progress>
                    <p class="otp-tip" style="margin: 8px 0 4px;">{{ batchStatusText }}</p>
                    <p v-if="batchCountsText" class="otp-tip" style="margin: 0 0 8px; color: #303133; font-weight: 500;">{{ batchCountsText }}</p>
                    <el-input type="textarea" :rows="8" :value="batchLog.join('\n')" readonly></el-input>
                  </div>
                </div>
              </div>
        </el-form>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeUploader from '@/components/ApeUploader'
import I18nLangBar from '@/components/I18nLangBar'
import i18nContentMixin from '@/mixins/i18nContentMixin'
import { mapGetters } from 'vuex'
import { buildUploadAuthHeaders } from '@/utils/request'

export default {
  components: {
    PageHeaderLayout,
    ApeUploader,
    I18nLangBar,
  },
  mixins: [i18nContentMixin],
  data() {
    return {
      i18nEntityType: 'setting',
      i18nFieldKeys: ['web_name', 'copyright', 'seo_title', 'seo_keywords', 'seo_description', 'address', 'customize_info'],
      targetLangChecks: ['zh', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'tw', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th'],
      allTargetLangs: ['zh', 'tw', 'en', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th'],
      newTargetLangs: ['nl', 'pl', 'it', 'fr', 'de', 'pt', 'tw', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th'],
      uploadHeaders:{},
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '玩命提交中……',
      searchCondition:{
        "current_page": 1,
        "page_size": 1,
        "query":"",
        "params":[""]
      },
      // 站点基本信息表单结构
      formData:{
        customize_info:[],
        translate_access_key:''
      },
      // 已上传文件列表
      uploadFileList:[],
      // 站点基本信息规则
      rules: {
        web_name: [
          {required: true, message: '输入站点名称', trigger: 'blur' },
        ],
      },
      batchTypeOptions: [
        { value: 'setting', label: '站点设置' },
        { value: 'article', label: '文章' },
        { value: 'category', label: '文章分类' },
        { value: 'fqa', label: 'FAQ' },
        { value: 'fqa_category', label: 'FAQ分类' },
        { value: 'craft', label: '工艺' },
        { value: 'craft_category', label: '工艺分类' },
        { value: 'craft_material', label: '材料' },
        { value: 'material_duration', label: '交期' },
        { value: 'follow_craft', label: '后处理' },
        { value: 'material_color', label: '材料颜色' },
      ],
      batchTypes: ['setting', 'article', 'category', 'fqa', 'fqa_category', 'craft', 'craft_category', 'craft_material', 'material_duration', 'follow_craft', 'material_color'],
      batchCheckAll: true,
      batchIndeterminate: false,
      batchLimit: 40,
      batchRunning: false,
      batchStarting: false,
      batchJobId: '',
      batchPollTimer: null,
      batchLog: [],
      batchStatusText: '',
      batchCountsText: '',
      batchPercent: 0,
      batchProgressStatus: null,
      providerModels: [],
      modelLoading: false,
      modelFetchHint: '',
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    resolvedSourceLang() {
      const s = (this.formData.translate_source_lang || 'auto').toLowerCase()
      if (s === 'auto') return this.sourceLang || 'en'
      return s
    }
  },
  methods: {
    checkAllTargetLangs() {
      this.targetLangChecks = [...this.allTargetLangs]
    },
    uncheckAllTargetLangs() {
      this.targetLangChecks = []
    },
    checkNewLangs() {
      this.targetLangChecks = [...this.newTargetLangs]
    },
    syncTargetLangsToForm() {
      const src = (this.formData.translate_source_lang || 'en').toLowerCase()
      const list = (this.targetLangChecks || []).filter(l => l && l !== src && l !== 'auto')
      this.formData.translate_target_langs = list.join(',')
    },
    // 生成随机接口访问 Key（32 位，避开 0/O/l/I 等易混字符）
    genAccessKey() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'
      const buf = new Uint32Array(32)
      if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(buf)
      } else {
        for (let i = 0; i < buf.length; i++) buf[i] = Math.floor(Math.random() * 0xffffffff)
      }
      let out = ''
      for (let i = 0; i < buf.length; i++) out += chars[buf[i] % chars.length]
      this.$set(this.formData, 'translate_access_key', out)
    },
    isEditingSourceLang() {
      return !this.formData.id || this.contentLang === this.resolvedSourceLang
    },
    async onSettingLangChange(lang) {
      this.contentLang = lang
      if (!this.sourceSnapshot) return
      // restore all fields from source snapshot first
      const snap = { ...this.sourceSnapshot }
      snap.customize_info = this.normalizeCustomizeInfo(snap.customize_info)
      Object.keys(snap).forEach(k => {
        this.$set(this.formData, k, snap[k])
      })
      if (lang === this.resolvedSourceLang || !this.formData.id) {
        return
      }
      // load this language into the same main form fields
      const res = await this.$api.post('/service/ola_app_setting/detail', {
        id: this.formData.id,
        lang
      })
      if (!this.$apiSuccess(res) || !res.data.detail) return
      const d = res.data.detail
      const fields = this.i18nFieldKeys || []
      fields.forEach(k => {
        if (d[k] == null || d[k] === '') return
        if (k === 'customize_info') {
          this.$set(this.formData, k, this.normalizeCustomizeInfo(d[k]))
        } else {
          this.$set(this.formData, k, d[k])
        }
      })
    },
    async onSettingTranslated() {
      await this.onSettingLangChange(this.contentLang)
    },
    async saveLocalizedFields() {
      const fields = this.i18nFieldKeys || []
      for (let i = 0; i < fields.length; i++) {
        const field_key = fields[i]
        let field_value = this.formData[field_key]
        if (field_key === 'customize_info') {
          field_value = JSON.stringify(this.normalizeCustomizeInfo(field_value))
        } else if (field_value == null) {
          field_value = ''
        } else {
          field_value = String(field_value)
        }
        const res = await this.$api.post('/service/i18n/update', {
          entity_type: 'setting',
          entity_id: this.formData.id,
          locale: this.contentLang,
          field_key,
          field_value
        })
        if (!this.$apiSuccess(res)) {
          throw new Error(res.message || `保存字段 ${field_key} 失败`)
        }
      }
    },
    async fetchProviderModels() {
      const base = (this.formData.translate_base_url || '').trim()
      const key = (this.formData.translate_api_key || '').trim()
      if (!base || !key) {
        this.$message.warning('请先填写 Base URL 和 API Key')
        return
      }
      this.modelLoading = true
      this.modelFetchHint = ''
      try {
        const res = await this.$api.post('/service/i18n/models', {
          base_url: base,
          api_key: key,
        })
        if (this.$apiSuccess(res)) {
          this.providerModels = res.data.models || []
          this.modelFetchHint = `共 ${this.providerModels.length} 个可用模型，勾选一个后保存设置`
          if (this.formData.translate_model && this.providerModels.indexOf(this.formData.translate_model) === -1) {
            // keep manual value; user can still pick another
          } else if (!this.formData.translate_model && this.providerModels.length) {
            // prefer flash / mini if present
            const prefer = this.providerModels.find(m => /flash|mini|lite/i.test(m))
            this.formData.translate_model = prefer || this.providerModels[0]
          }
          this.$message.success('模型列表已更新')
        } else {
          this.providerModels = []
          this.modelFetchHint = res.message || '拉取失败'
          this.$message.error(this.modelFetchHint)
        }
      } catch (e) {
        this.providerModels = []
        this.modelFetchHint = (e && e.message) ? e.message : '拉取异常'
        this.$message.error(this.modelFetchHint)
      } finally {
        this.modelLoading = false
      }
    },
    onBatchCheckAll(val) {
      this.batchTypes = val ? this.batchTypeOptions.map(t => t.value) : []
      this.batchIndeterminate = false
    },
    onBatchTypesChange(val) {
      const n = val.length
      this.batchCheckAll = n === this.batchTypeOptions.length
      this.batchIndeterminate = n > 0 && n < this.batchTypeOptions.length
    },
    clearBatchPoll() {
      if (this.batchPollTimer) {
        clearInterval(this.batchPollTimer)
        this.batchPollTimer = null
      }
    },
    applyBatchJob(job, remain) {
      if (!job) return
      this.batchJobId = job.id || ''
      this.batchPercent = Math.min(100, Math.max(0, Number(job.percent || 0)))
      this.batchStatusText = job.status_text || ''
      const processed = Number(job.processed || 0)
      const total = Number(job.total_entities || 0)
      const rem = remain != null ? Number(remain) : Math.max(0, total - processed)
      const typePart = job.current_type_label
        ? `当前：${job.current_type_label} ${job.type_offset || 0}/${job.type_total || 0}`
        : ''
      this.batchCountsText = [
        `已处理 ${processed}/${total}`,
        `剩余 ${rem}`,
        `更新 ${job.updated_fields || 0}`,
        `跳过 ${job.skipped_fields || 0}`,
        `错误 ${job.error_count || 0}`,
        typePart,
      ].filter(Boolean).join(' · ')
      const log = String(job.log_text || '').trim()
      this.batchLog = log ? log.split('\n') : []
      const st = job.status
      this.batchRunning = st === 'running'
      if (st === 'done') {
        this.batchProgressStatus = Number(job.error_count || 0) > 0 ? 'warning' : 'success'
        this.batchPercent = 100
      } else if (st === 'stopped') {
        this.batchProgressStatus = 'warning'
      } else if (st === 'error') {
        this.batchProgressStatus = 'exception'
      } else {
        this.batchProgressStatus = null
      }
    },
    async fetchBatchStatus(opts = {}) {
      const announceDone = !!opts.announceDone
      try {
        const body = this.batchJobId ? { job_id: this.batchJobId } : {}
        const res = await this.$api.post('/service/i18n/batch_status', body)
        if (!this.$apiSuccess(res)) return
        const job = (res.data && res.data.job) || null
        if (!job) return
        const wasRunning = this.batchRunning
        this.applyBatchJob(job, res.data.remain)
        if (job.status !== 'running') {
          this.clearBatchPoll()
          if (announceDone && wasRunning && job.status === 'done') {
            this.$message.success('历史翻译补全完成')
          }
        } else if (!this.batchPollTimer) {
          this.startBatchPoll()
        }
      } catch (e) {
        // keep polling; transient network errors are ok
      }
    },
    startBatchPoll() {
      this.clearBatchPoll()
      this.batchPollTimer = setInterval(() => {
        this.fetchBatchStatus({ announceDone: true })
      }, 1500)
    },
    async stopBatchTranslate() {
      this.batchStatusText = '正在停止…'
      try {
        await this.$api.post('/service/i18n/batch_stop', { job_id: this.batchJobId || '' })
        await this.fetchBatchStatus({ announceDone: false })
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '停止失败')
      }
    },
    async startBatchTranslate() {
      if (!this.formData.translate_base_url || !this.formData.translate_api_key || !this.formData.translate_model) {
        this.$message.warning('请先填写并保存翻译供应商配置')
        return
      }
      if (!this.batchTypes.length) {
        this.$message.warning('请至少选择一种内容类型')
        return
      }
      this.batchStarting = true
      this.batchProgressStatus = null
      try {
        const res = await this.$api.post('/service/i18n/batch_start', {
          entity_types: this.batchTypes,
          limit: this.batchLimit,
        })
        if (!this.$apiSuccess(res)) {
          this.$message.error(res.message || '启动失败')
          return
        }
        const job = res.data || {}
        this.applyBatchJob(job, Math.max(0, Number(job.total_entities || 0) - Number(job.processed || 0)))
        this.batchRunning = true
        this.startBatchPoll()
        this.$message.success('已在服务端启动，刷新页面可继续查看进度')
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '启动异常')
      } finally {
        this.batchStarting = false
      }
    },
    normalizeCustomizeInfo(raw) {
      if (Array.isArray(raw)) return raw
      if (typeof raw === 'string') {
        try {
          const parsed = JSON.parse(raw)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    handleAvatarSuccess(res) {
      this.formData.web_logo = res.data;
    },
    beforeAvatarUpload(file) {
      this.uploadHeaders = buildUploadAuthHeaders()
      const isJPG = file.type === "image/jpeg"||file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['articleForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 站点相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      this.syncTargetLangsToForm()
      try {
        if (this.formData.id && !this.isEditingSourceLang()) {
          await this.saveLocalizedFields()
          this.$notify.success('译文已保存')
          this.loadingStaus = false
          return
        }
        const submitData = {
          ...this.formData,
          customize_info: JSON.stringify(this.normalizeCustomizeInfo(this.formData.customize_info)),
        }
        if(this.formData.id==undefined||this.formData.id==''){
          let res = await this.$api.post('/service/ola_app_setting/create',submitData)
          if (this.$apiSuccess(res)){
            this.$notify.success('保存成功！')
          }
        }else{
          let res = await this.$api.post('/service/ola_app_setting/update',submitData)
          if (this.$apiSuccess(res)){
             this.$notify.success('保存成功！其它语言将按配置自动翻译')
             this.captureSourceSnapshot({
               ...this.formData,
               customize_info: this.normalizeCustomizeInfo(this.formData.customize_info)
             }, this.i18nFieldKeys)
          }
        }
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '保存失败')
      }
      this.$nextTick(() => {
        this.loadingStaus = false
      }) 
    },
    addItem() {
      this.formData.customize_info.push({key:'',value:''})
    },
    deleteItem(item){
      this.formData.customize_info.splice(item,1)
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.web_logo = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.web_logo = 0
      this.uploadFileList = fileList
    },
    // 初始化站点基本信息
    async initSettingSiteForm() {
      // 获取站点分类列表
      let res = await this.$api.post('/service/ola_app_setting/detail',this.searchCondition)
      if (this.$apiSuccess(res)){
        const detail = res.data.detail
        detail.customize_info = this.normalizeCustomizeInfo(detail.customize_info)
        if (detail.otp_enabled !== '1') {
          detail.otp_enabled = '0'
        }
        if (!detail.translate_source_lang) {
          detail.translate_source_lang = 'auto'
        }
        if (!detail.translate_target_langs) {
          detail.translate_target_langs = 'zh,ar,es,ru,nl,pl,it,fr,de,pt,tw,ja,ko,hi,tr,id,ur,vi,th'
        }
        this.targetLangChecks = String(detail.translate_target_langs).split(',').map(s => s.trim()).filter(Boolean)
        this.captureSourceSnapshot(detail, this.i18nFieldKeys)
        this.contentLang = this.sourceLang
      }
    },
  },
  async mounted() {
    this.uploadHeaders = buildUploadAuthHeaders()
    this.loadingStaus = true
    await this.loadI18nMeta()
    await this.initSettingSiteForm()
    await this.fetchBatchStatus()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
  beforeDestroy() {
    this.clearBatchPoll()
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 表单卡片通用样式
.form-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .card-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .card-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .card-actions
      .el-button
        height 32px
        padding 0 16px
        border-radius 6px
        font-size 13px
        
  .card-content
    /deep/ .el-form-item
      margin-bottom 20px
      
      .el-form-item__label
        color #606266
        font-weight 500
        
      .el-input__inner, .el-textarea__inner
        border-radius 6px
        border-color #e4e7ed
        transition all 0.3s ease
        
        &:focus
          border-color #409EFF
          box-shadow 0 0 0 2px rgba(64,158,255,0.1)
          
      .el-textarea__inner
        font-family inherit
        resize vertical

// 左侧内容区域
.content-left
  /deep/ .el-form-item__label
    text-align left !important
    
// 右侧内容区域
.content-right
  /deep/ .el-form-item__label
    text-align left !important
    padding 0 0 8px 0 !important
    
  /deep/ .el-form-item__content
    margin-left 0 !important

// LOGO上传样式
.logo-upload
  .avatar-uploader
    /deep/ .el-upload
      border 2px dashed #d9d9d9
      border-radius 8px
      cursor pointer
      position relative
      overflow hidden
      transition all 0.3s ease
      width 200px
      height 120px
      display flex
      align-items center
      justify-content center
      
      &:hover
        border-color #409EFF
        
    .avatar
      width 180px
      height 100px
      object-fit contain
      border-radius 4px
      
    .upload-placeholder
      text-align center
      color #8c939d
      
      .avatar-uploader-icon
        font-size 28px
        margin-bottom 8px
        display block
        
      .upload-text
        font-size 14px
        
  .upload-tips
    margin-top 12px
    
    p
      font-size 12px
      color #909399
      margin 4px 0
      line-height 1.4
      
      &:before
        content ''
        display inline-block
        width 4px
        height 4px
        background #C0C4CC
        border-radius 50%
        margin-right 6px
        vertical-align middle

  .otp-tip
    margin-top 8px
    font-size 12px
    color #909399
    line-height 1.5

.model-picker
  width 100%
.access-key-row
  display flex
  gap 8px
  width 100%
.model-radio-group
  display flex
  flex-wrap wrap
  gap 8px
  margin-top 10px
  max-height 220px
  overflow-y auto
.model-radio
  margin 0 !important

// 目标语言 20 项复选框：两列布局防溢出
.target-lang-group
  display flex
  flex-wrap wrap
  gap 4px 18px
  width 100%
  /deep/ .el-checkbox
    margin 0 !important
    width 220px
.target-lang-actions
  margin-top 6px

// 自定义表格样式
.custom-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0
          padding 12px 0
          
          .el-input__inner
            border none
            background transparent
            
            &:focus
              background #fff
              border 1px solid #409EFF

// 操作按钮样式
.action-buttons
  text-align center
  
  .save-btn
    height 44px
    padding 0 32px
    border-radius 8px
    font-weight 500
    font-size 16px
    background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
    border none
    box-shadow 0 4px 12px rgba(64,158,255,0.3)
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 6px 16px rgba(64,158,255,0.4)
      
    &:disabled
      transform none
      box-shadow 0 2px 8px rgba(64,158,255,0.2)
      opacity 0.7

// 响应式设计
@media (max-width: 1200px)
  .content-left
    margin-bottom 24px
    
  .content-right
    /deep/ .el-col
      width 100% !important

@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .form-card
    padding 16px
    
    .card-header
      flex-direction column
      align-items flex-start
      gap 12px
      
    .card-content
      /deep/ .el-form-item__label
        width 100% !important
        text-align left !important
        
  .logo-upload
    text-align center
    
    .avatar-uploader
      /deep/ .el-upload
        width 160px
        height 100px
        
    .avatar
      width 140px
      height 80px
      
  .custom-table
    overflow-x auto
</style>
